import axiosInstance from 'api/axiosInstance';

export interface Address {
  Id: number;
  Name: string;
  Title?: string;
  AddressLine1?: string;
  City?: string;
  [key: string]: any;
}

export interface SearchAddressesParams {
  CustomerId: string | number;
  SearchKeyword?: string;
  Page?: number;
  Take?: number;
}

export const searchAddresses = async (
  params: SearchAddressesParams
): Promise<Address[]> => {
  try {
    const payload = {
      CustomerId: params.CustomerId,
      SearchKeyword: params.SearchKeyword || '',
      Page: params.Page || 1,
      Take: params.Take || 100,
    };

    const response = await axiosInstance.get(
      '/api/candispatchv3/SearchAddresses',
      {
        params: payload,
        paramsSerializer: (params) => `payload=${JSON.stringify(params)}`,
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        },
        data: null,
      }
    );

    const data = response.data?.Data || response.data || [];
    if (!Array.isArray(data)) return [];

    // Map Title to Name for consistency with component usage
    return data.map((item: any) => ({
      ...item,
      Name: item.Title || item.Name || '',
    }));
  } catch (error) {
    console.error('Error searching addresses:', error);
    throw error;
  }
};

export default searchAddresses;
